import { render, staticRenderFns } from "./TosForm.vue?vue&type=template&id=6a8c227f"
import script from "./TosForm.vue?vue&type=script&lang=js"
export * from "./TosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports